module.exports = __webpack_public_path__ + "img/red-graph.7448e7fd.svg";